import { Screen } from "./Frames";

const Palm = ({ className, flip }) => (
  <svg viewBox="0 0 200 400" className={className} style={flip ? { transform: "scaleX(-1)" } : undefined} aria-hidden>
    <path d="M100 400 C 104 300, 112 200, 128 112" stroke="#03080c" strokeWidth="9" fill="none" strokeLinecap="round" />
    <g fill="#03080c">
      <path d="M128 112 C 90 80, 40 86, 6 120 C 46 100, 92 104, 128 116 Z" />
      <path d="M128 112 C 108 64, 70 40, 30 38 C 70 58, 100 84, 126 118 Z" />
      <path d="M128 112 C 140 62, 176 36, 200 34 C 172 60, 148 88, 130 118 Z" />
      <path d="M128 112 C 170 92, 196 110, 200 150 C 180 124, 158 116, 130 116 Z" />
      <path d="M128 112 C 120 150, 92 180, 60 196 C 90 168, 110 142, 126 114 Z" />
      <path d="M128 112 C 150 140, 160 176, 156 210 C 146 176, 136 146, 128 116 Z" />
    </g>
  </svg>
);

export const Billboard = ({ src, alt }) => (
  <figure className="relative overflow-hidden rounded-xl" style={{ aspectRatio: "16/9" }} data-testid="frame-billboard">
    <div className="billboard-sky absolute inset-0" aria-hidden />
    <div className="absolute left-[68%] top-[70%] h-[50%] w-[40%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#ffd58a]/40 blur-3xl" aria-hidden />
    <div className="absolute inset-x-0 bottom-0 h-[16%] bg-gradient-to-b from-[#0b1418] to-[#020405]" aria-hidden />
    <div className="absolute bottom-[15.5%] left-0 right-0 h-px bg-[#f3d39a]/30" aria-hidden />
    <Palm className="absolute bottom-[10%] left-[-2%] h-[78%]" />
    <Palm className="absolute bottom-[12%] left-[9%] h-[52%] opacity-90" flip />
    <Palm className="absolute bottom-[10%] right-[-3%] h-[86%]" flip />
    <div className="absolute left-[44%] top-[50%] bottom-[14%] w-[1.4%] bg-gradient-to-r from-[#1a1d1f] via-[#3a3f43] to-[#1a1d1f]" aria-hidden />
    <div className="absolute left-[55%] top-[50%] bottom-[14%] w-[1.4%] bg-gradient-to-r from-[#1a1d1f] via-[#3a3f43] to-[#1a1d1f]" aria-hidden />
    <div className="absolute left-1/2 top-[11%] w-[66%] -translate-x-1/2">
      <div className="mb-[0.6%] flex justify-around px-[8%]" aria-hidden>
        {[0, 1, 2].map((i) => (
          <span key={i} className="h-[clamp(3px,0.5vw,7px)] w-[8%] rounded-sm bg-[#2a2e31]" />
        ))}
      </div>
      <div className="relative border-[clamp(3px,0.6vw,8px)] border-[#17191b] bg-black shadow-[0_30px_60px_-20px_rgba(0,0,0,0.8)]">
        <Screen src={src} alt={alt} ratio="2.3/1" position="center" />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-white/15 via-transparent to-black/20" aria-hidden />
      </div>
      <div className="mx-[-1%] mt-[0.8%] h-[clamp(3px,0.5vw,7px)] bg-[#24282b]" aria-hidden />
    </div>
  </figure>
);
